import React from 'react';
import { Link } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { connect } from 'react-redux';
import { resetPasswordAction } from '../../../modules/auth/Actions';
import { authIsLoadingSelector } from '../../../modules/auth/Selectors';
import * as Yup from 'yup';
import { newErrorNotificationAction } from '../../../modules/notifications/Actions';
import getLangData from '../../../utils/getLangData';

const schema = () =>
  Yup.object({
    password: Yup.string()
      .required('Password is required')
      .default(''),
    passwordConfirmation: Yup.string()
      .default('')
      .oneOf([Yup.ref('password'), null], getLangData().general_words.match_password)
  });

const ResetPassword = props => {
  const { loginUser, isLoading = true, resetPassword, errorAction } = props;
  return (
    <Formik
      // validationSchema={schema()}
      initialValues={{
        password: '',
        passwordConfirmation: ''
      }}
      onSubmit={(values, { setSubmitting }) => {
        const token = props.match.params.token;
        if (values.password !== values.passwordConfirmation) {
          errorAction('Password Does Not Match');
          console.log('donet match');
        } else if (values.password === values.passwordConfirmation) {
          setSubmitting(true);
          try {
            resetPassword(token, values.password);
          } catch (err) {
            console.log(err);
          } finally {
            setSubmitting(false);
          }
        }
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        errorAction
      }) => (
        <Form className='row fancy--login' onSubmit={handleSubmit}>
          <div
            className='left--section col-5 lazyload'
            data-bg='/assets/images/09.png'
            style={{
              background: 'url(/assets/images/09.png)',
              backgroundPosition: 'center',
              backgroundSize: 'cover'
            }}
          >
            <div className='inner'>
              <img className='logo' src='assets/images/favicons.png' alt='' />
              <div className='title'>
                <p className='small'>Welcome to</p>
                <p>Warshatna!</p>
              </div>
              <div className='links'>
                <ul>
                  <li>
                    <a href='#'>Privacy</a>
                  </li>
                  <li>
                    <a href='#'>Legal</a>
                  </li>
                  <li>
                    <a href='#'>Contact</a>
                  </li>
                </ul>
                <p>© 2020 - 2021 Warshatna</p>
              </div>
            </div>
          </div>
          <div className='right--section col-7'>
            <div className='form'>
              <h3>Reset Password</h3>
              <p className='small mb-4'>Enter your login details below</p>
              <form action='#' className='custom--form'>
                <div className='input-group mb-3'>
                  <input
                    onChange={handleChange}
                    id='password'
                    name='password'
                    type='password'
                    // onkeyup="this.setAttribute('value', this.value);"
                    required
                  />
                  <label>Passowrd</label>
                </div>

                <div className='input-group mb-3'>
                  <input
                    onChange={handleChange}
                    id='passwordConfirmation'
                    name='passwordConfirmation'
                    type='password'
                    // onkeyup="this.setAttribute('value', this.value);"
                    required
                  />
                  <label>Confirm Password</label>
                </div>
                <div className='m-auto pt-4 submit'>
                  {/* <input type="submit"  className="btn btn-primary mb-4"   defaultValue="Sign In"/> */}
                  <button
                    disabled={isLoading}
                    type='submit'
                    className={`btn btn-primary mb-4 ${
                      isLoading ? `kt-spinner` : ``
                    }`}
                    style={{ width: '100%' }}
                  >
                    {isLoading ? (
                      <div style={{ margin: 'auto' }} class='loader'></div>
                    ) : (
                      'Reset Password'
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

const mapStateToProps = state => {
  return {
    isLoading: authIsLoadingSelector(state)
  };
};

const mapDispatchToProps = {
  resetPassword: resetPasswordAction,
  errorAction: newErrorNotificationAction
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
